// extracted by mini-css-extract-plugin
module.exports = {"navbarBrand":"youview-logo-module--navbarBrand--h2cKO"};